import React from "react"

const Card = ({ className = "", type = "", tag = "", children, ...otherProps }) => {
  const Tag = tag ? tag : "div"
  return <Tag className={`card ${type} ${className}`} {...otherProps}>{children}</Tag>
}

export default Card
